import { googleMapInit } from './googleMapService'

async function setRoute(origin, destination, stops) {
  const google = await googleMapInit()
  const service = new google.maps.DirectionsService()

  const params = {
    origin: origin,
    destination: destination,
    waypoints: stops,
    optimizeWaypoints: true,
    travelMode: 'DRIVING',
    avoidTolls: true,
    avoidFerries: true
  }

  const result = new Promise((resolve, reject) => {
    service.route(params, (response, status) => {
      if (status === 'OK') {
        resolve(response)
      } else {
        reject(response)
      }
    })
  })

  return result
    .then(resultRes => resultRes)
    .catch(err => console.log('some error occurred >>>', err))
}

export default setRoute
